const STEPS = [
  {
    number: "01",
    icon: "ri-phone-fill",
    title: "Call or Request Online",
    desc: "Call (540) 776-4488 or submit our quick online form. We respond within hours — not days. Same-day emergency appointments available.",
    accent: "bg-[#e8632a]",
  },
  {
    number: "02",
    icon: "ri-search-eye-fill",
    title: "Free On-Site Assessment",
    desc: "An ISA Certified Arborist visits your property, evaluates the tree(s), and walks you through the safest, most cost-effective approach.",
    accent: "bg-[#1a3a2e]",
  },
  {
    number: "03",
    icon: "ri-file-text-fill",
    title: "Transparent Written Quote",
    desc: "You receive a detailed written estimate — every item itemized. No surprises. No pressure. Take your time to decide.",
    accent: "bg-[#e8632a]",
  },
  {
    number: "04",
    icon: "ri-tools-fill",
    title: "Expert Work Completed",
    desc: "Our crew arrives on time with pro-grade equipment. Precision rigging, certified climbers, and zero shortcuts on safety.",
    accent: "bg-[#1a3a2e]",
  },
  {
    number: "05",
    icon: "ri-check-double-fill",
    title: "Full Cleanup & Walkthrough",
    desc: "Every log, branch, and wood chip removed (or spread as mulch). We walk you through the completed work before we leave.",
    accent: "bg-[#e8632a]",
  },
];

export default function ProcessSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-16 items-start">
          {/* Left: sticky header */}
          <div className="lg:sticky lg:top-28">
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-[3px] block mb-4">How It Works</span>
            <h2 className="text-4xl font-black text-[#1e1e1e] leading-tight mb-5">
              Our Simple<br />
              5-Step<br />
              <span className="text-[#1a3a2e]">Process</span>
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              From first call to final cleanup — you'll always know what to expect. No surprise fees, no unanswered questions.
            </p>
            <a
              href="tel:+15407764488"
              className="flex items-center gap-2 px-6 py-3 bg-[#e8632a] text-white font-black rounded-xl uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer whitespace-nowrap inline-flex"
            >
              <i className="ri-phone-fill"></i>
              Start Now — It's Free
            </a>
          </div>

          {/* Right: step cards */}
          <div className="lg:col-span-2 space-y-4">
            {STEPS.map((step, i) => (
              <div
                key={step.number}
                className="flex gap-5 bg-[#f8f6f3] rounded-2xl p-6 hover:translate-x-1 transition-transform"
              >
                {/* Number + icon */}
                <div className="flex flex-col items-center gap-2 flex-shrink-0">
                  <div className={`w-12 h-12 flex items-center justify-center rounded-2xl text-white flex-shrink-0 ${step.accent}`}>
                    <i className={`${step.icon} text-xl`}></i>
                  </div>
                  {i < STEPS.length - 1 && (
                    <div className="w-0.5 h-6 bg-gray-200 rounded-full"></div>
                  )}
                </div>

                <div className="pt-1">
                  <div className="flex items-center gap-2.5 mb-2">
                    <span className="text-[#e8632a] font-black text-xs uppercase tracking-[2px]">Step {step.number}</span>
                  </div>
                  <h3 className="font-black text-[#1e1e1e] text-lg mb-2">{step.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
